(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9109],{

/***/ 62478:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external/bb-visitor-sync",
      function () {
        return __webpack_require__(13843);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BigBrainScript; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./components/core/head/products-service.js



var _obj;
var CLUSTER_TO_PRODUCT_ID = (_obj = {}, (0,_define_property/* default */.Z)(_obj, clusters.CONSTRUCTION, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.HR, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.OPERATIONS, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.IT, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.PMO, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.PRODUCT_MANAGEMENT, products/* DEV_PRODUCT_ID */.xi), (0,_define_property/* default */.Z)(_obj, clusters.DESIGN_AND_CREATIVE, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.TASKS_AND_TODOS, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.FINANCE, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.CREATIVE, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.CRM, products/* CRM_PRODUCT_ID */.$), (0,_define_property/* default */.Z)(_obj, clusters.SOFTWARE, products/* DEV_PRODUCT_ID */.xi), (0,_define_property/* default */.Z)(_obj, clusters.WORK_MANAGEMENT, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.MARKETING, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.FUNDRAISING, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.NON_PROFIT, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.PROJECTS_FLOW, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), _obj);
var getProductTypeFromCluster = function(clusterId) {
    return CLUSTER_TO_PRODUCT_ID[clusterId];
};

;// CONCATENATED MODULE: ./components/core/head/bigbrain-script.js







var BIGBRAIN_SCRIPT_URL = "https://informer-cdn2.monday.com/monday-informer-1.0.min.js";
var BIGBRAIN_URL = "https://data.bigbrain.me" || 0;
var BigBrainScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BigBrainScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BigBrainScript);
    function BigBrainScript() {
        (0,_class_call_check/* default */.Z)(this, BigBrainScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BigBrainScript, [
        {
            key: "renderBigBrainTracker",
            value: function renderBigBrainTracker(template, isProduction, pageType, clusterId, subClusterId, preventPageView, createVisitor, crossDomain, emitVisitorId, emitTargetOrigin, segmentsList, pageProductId, exactPageAbTest, crossOriginLocaleAbTest) {
                var clusterIdToTrack = clusterId ? "".concat(clusterId).concat(subClusterId ? ",".concat(subClusterId) : "") : "undefined";
                var exactPageAbTestTrack = exactPageAbTest ? "BigBrain('track', \"".concat(exactPageAbTest.name, '", { ab_test: "').concat(exactPageAbTest.variant, '" });') : "";
                var crossOriginAbTestTrack = crossOriginLocaleAbTest ? "BigBrain('track', \"".concat(crossOriginLocaleAbTest.name, '", { ab_test: "').concat(crossOriginLocaleAbTest.variant, '" });') : "";
                return "\n      var brand_name = 'monday.com';\n      var template = '".concat(template, '\';\n\n      function add_general_event_props(args) {\n        event_props = {};\n        if(args.length == 3) {\n          event_props = args[2];\n        }\n\n        event_props[\'timestamp\'] = parseInt(new Date().getTime()/1000);\n        event_props["source"] = event_props["source"] || "monday_homepage";\n        event_props["group"] = "website";\n\n        if (args.length == 2) {\n          args.push(event_props);\n        }\n        else {\n          args[2] = event_props;\n        }\n        return args;\n      }\n\n      if (').concat(isProduction, ") {\n        window.BigBrainQ = window.BigBrainQ || [];\n        window.BigBrain = window.BigBrain || function(){\n          args = Array.prototype.slice.call(arguments)\n          if(args[0] == 'track'){\n            args = add_general_event_props(args)\n          }\n          window.BigBrainQ.push(args);\n        };\n\n        (function(d,u,callback){\n          if (window.BigBrainInit) return;\n          window.BigBrainInit = true;\n          var s = d.createElement('script');\n          s.type = 'text/javascript'\n          s.src = u;\n          s.async = true;\n          s.onreadystatechange = s.onload = function(){\n            var st = s.readyState;\n            if (!callback.done && (!st || /loaded|complete/.test(st))) {\n              callback.done = true;\n              callback();\n            }\n          };\n          (d.body || d.head).appendChild(s);\n        })(document, '").concat(BIGBRAIN_SCRIPT_URL, "', function() { \n            window.BigBrain = new BigBrainTracker({bigbrain_url: '").concat(BIGBRAIN_URL, "', send_immediately: true, create_visitor: ").concat(createVisitor, ", is_tracker_cross_domain: ").concat(!!crossDomain, ", emit_visitor_id: ").concat(!!emitVisitorId, ', emit_target_origin: "').concat(emitTargetOrigin, "\"});\n        });\n\n      } else {\n        window.BigBrain = function() {\n          args = Array.prototype.slice.call(arguments)\n          if(args[0] == 'track' || args[0] == 'set_utm_cluster_id'  ||  args[0] == 'set_utm_locale_id') {\n            args = add_general_event_props(args)\n            argsn = args.map(function(t) {\n              if (typeof(t) === 'object')\n                return JSON.stringify(t);\n              else\n                return t;\n            });\n            console.info(argsn);\n          }\n        }\n      }\n\n      if (").concat(!preventPageView, ") {\n        var type = document.getElementsByTagName('body')[0].dataset.pageType || '").concat(pageType, "';\n        if (type === undefined || (typeof (type) == 'string' && type.length == 0) || type == 'homepage'){\n          type = 'homepage';\n        } else {\n          type = '").concat(pageType, '\';\n        }\n        window.visitGuid = window.visitGuid || Math.ceil(Math.random() * 10000000);\n        var options = {\n          kind: location.pathname, \n          source: type, info2: template || "", \n          info3: location.href, \n          direct_object: window.visitGuid, \n          info1: "').concat(clusterIdToTrack, '", \n          data: {\n            segments: "').concat(segmentsList, '",\n            windowInnerWidth: window.innerWidth,\n            windowInnerHeight: window.innerHeight,\n            product: "').concat(pageProductId || getProductTypeFromCluster(clusterId) || "undefined", "\"\n          }\n        };\n        BigBrain('track', 'page_view', options);\n        ").concat(exactPageAbTestTrack, "\n        ").concat(crossOriginAbTestTrack, "\n      }\n  ");
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, template = _props.template, isProduction = _props.isProduction, pageType = _props.pageType, clusterId = _props.clusterId, subClusterId = _props.subClusterId, preventPageView = _props.preventPageView, createVisitor = _props.createVisitor, crossDomain = _props.crossDomain, emitVisitorId = _props.emitVisitorId, emitTargetOrigin = _props.emitTargetOrigin, segmentsList = _props.segmentsList, pageProductId = _props.pageProductId, exactPageAbTest = _props.exactPageAbTest, crossOriginLocaleAbTest = _props.crossOriginLocaleAbTest;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    dangerouslySetInnerHTML: {
                        __html: this.renderBigBrainTracker(template, isProduction, pageType, clusterId, subClusterId, preventPageView, createVisitor, crossDomain, emitVisitorId, emitTargetOrigin, segmentsList, pageProductId, exactPageAbTest, crossOriginLocaleAbTest)
                    }
                });
            }
        }
    ]);
    return BigBrainScript;
}(react.PureComponent);

BigBrainScript.defaultProps = {
    pageType: "homepage",
    createVisitor: true
};


/***/ }),

/***/ 13843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BbVisitorSync; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(12918);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/core/head/bigbrain-script.js + 1 modules
var bigbrain_script = __webpack_require__(36403);
;// CONCATENATED MODULE: ./components/pages/external/bb-visitor-sync/bb-visitor-sync-component.js



var isProduction = "production" === "production";
var PAGE_TYPE = "external_sync";
var BbVisitorSyncComponent = function(param) {
    var source = param.source;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bigbrain_script/* default */.Z, {
                isProduction: isProduction,
                pageType: PAGE_TYPE,
                preventPageView: true,
                crossDomain: true,
                emitVisitorId: true,
                emitTargetOrigin: source
            })
        })
    });
};
/* harmony default export */ var bb_visitor_sync_component = (BbVisitorSyncComponent);

;// CONCATENATED MODULE: ./pages/external/bb-visitor-sync/index.js





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var getHostName = function(url) {
    try {
        var parsedUrl = new URL(url);
        var hostname = parsedUrl.hostname;
        var simplifiedHostname = hostname.replace(/^www\./, "");
        return simplifiedHostname;
    } catch (error) {
        return null;
    }
};
var BbVisitorSync = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BbVisitorSync, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BbVisitorSync);
    function BbVisitorSync() {
        (0,_class_call_check/* default */.Z)(this, BbVisitorSync);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BbVisitorSync, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, source = _props.source, statusCode = _props.statusCode;
                if (statusCode !== 200) return /*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
                    statusCode: statusCode
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(bb_visitor_sync_component, {
                    source: source
                });
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var req = param.req, res = param.res;
                return _async_to_generator(function() {
                    var _req_query, WHITE_LIST, source, host, statusCode;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        WHITE_LIST = new Set([
                            "workforms.com",
                            "mondayspaces.webflow.io",
                            "mondayspaces.com"
                        ]);
                        source = decodeURIComponent((req === null || req === void 0 ? void 0 : (_req_query = req.query) === null || _req_query === void 0 ? void 0 : _req_query.tsrc) || "");
                        host = getHostName(source);
                        if (!WHITE_LIST.has(host)) {
                            res.statusCode = 404;
                        }
                        statusCode = res.statusCode;
                        return [
                            2,
                            {
                                statusCode: statusCode,
                                source: source
                            }
                        ];
                    });
                })();
            }
        }
    ]);
    return BbVisitorSync;
}(react.PureComponent);

BbVisitorSync.defaultProps = {};


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 4111:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 60460:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0,_assert_this_initialized/* default */.Z)(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 88029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(62478); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);